import { Box, styled, useTheme } from '@material-ui/core';
import { SETVIImage, SText } from '@setvi/shared/components';
import SDatePicker from '@setvi/shared/components/sforms/sdate';
import moment from 'moment';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  position: 'relative',
  padding: theme.spacing(1, 3)
}));

const DatePickerContainer = styled(Box)({
  width: '360px'
});

interface ExpirationDateStepProps {
  date: Date | null;
  onChange: (date: Date) => void;
}

export const ExpirationDateStep = ({
  date,
  onChange
}: ExpirationDateStepProps) => {
  const { palette } = useTheme();
  const handleDateChange = (newDate: Date) => {
    onChange(newDate);
  };

  // Set minimum date to tomorrow
  const minDate = moment().add(1, 'day').startOf('day').toDate();

  // Set maximum date to 1 year from now
  const maxDate = moment().add(1, 'year').toDate();

  return (
    <Container>
      <SText size="lg" weight="bold">
        Expiration date{' '}
        <span style={{ color: palette.error.main, fontSize: 14 }}>*</span>
      </SText>

      <DatePickerContainer>
        <SDatePicker
          value={date}
          onChange={handleDateChange}
          minDate={minDate}
          maxDate={maxDate}
          hideCarret
          pickerLabel={
            <SETVIImage
              src="/icons/quotes-expiration-date.svg"
              alt="expiration date"
              width={24}
              height={24}
            />
          }
          placeholder="Select expiration date"
          format="MM/dd/yyyy"
          required
          placement="bottomStart"
        />
      </DatePickerContainer>
    </Container>
  );
};
